import { HEADER_MIN_HEIGHT, TABS_SIZE } from '../../../utils/constants';

export const headerScrollDistance = (headerHeight: number) => {
  return headerHeight > 0
    ? headerHeight - HEADER_MIN_HEIGHT - TABS_SIZE
    : HEADER_MIN_HEIGHT + TABS_SIZE;
};
